import { LogTypes, Note } from './commonInterfaces';

export const RESTRICTABLE_LOG_TYPES: ReadonlySet<LogTypes> = new Set([
  LogTypes.note,
  LogTypes.call,
  LogTypes.emailOrText,
  LogTypes.task,
  LogTypes.meeting,
]);

export function isRestrictableLogType(logType: LogTypes | undefined): boolean {
  return logType !== undefined && RESTRICTABLE_LOG_TYPES.has(logType);
}

export function canToggleRestrictionOnEdit(
  note: Note,
  viewerStaffId: number | undefined,
  isExecAdmin: boolean,
): boolean {
  if (viewerStaffId === undefined) {
    return false;
  }
  if (note.staffId === viewerStaffId) {
    return true;
  }
  const assignId = note.assignId;
  if (assignId !== undefined && assignId > 0 && assignId === viewerStaffId) {
    return true;
  }
  return isExecAdmin;
}

/** On a restricted note only the staff on the note or execAdmin may change its tags. */
export function canChangeTagsOnEdit(
  note: Note,
  viewerStaffId: number | undefined,
  isExecAdmin: boolean,
): boolean {
  if (!note.restrictionLevel) {
    return true;
  }
  return canToggleRestrictionOnEdit(note, viewerStaffId, isExecAdmin);
}

export function showRestrictedToggle(args: {
  logType: LogTypes | undefined;
  editNote: Note | undefined;
  viewerStaffId: number | undefined;
  isExecAdmin: boolean;
}): boolean {
  if (!isRestrictableLogType(args.logType)) {
    return false;
  }
  if (args.editNote) {
    return canToggleRestrictionOnEdit(args.editNote, args.viewerStaffId, args.isExecAdmin);
  }
  return true;
}

export const RESTRICT_EXISTING_NOTE_WARNING =
  'Notifications already sent and copies already made are not recalled.';

export function isLiftConfirmInputValid(input: string, expectedWord: string): boolean {
  return input === expectedWord;
}

export function showLiftRestrictionControl(
  editNote: Note | undefined,
  viewerStaffId: number | undefined,
  isExecAdmin: boolean,
): boolean {
  if (!editNote?.restrictionLevel) {
    return false;
  }
  return canToggleRestrictionOnEdit(editNote, viewerStaffId, isExecAdmin);
}
